import { render } from "./PaymentForm.vue?vue&type=template&id=06799dfe&scoped=true"
import script from "./PaymentForm.vue?vue&type=script&lang=js"
export * from "./PaymentForm.vue?vue&type=script&lang=js"

import "./PaymentForm.vue?vue&type=style&index=0&id=06799dfe&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.8.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06799dfe"]])

export default __exports__